import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from '../app-routing.module';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { FooterComponent } from './footer/footer.component';
import { MessageComponent } from './message/message.component';
import { NavComponent } from './nav/nav.component';
import { UserCheckEntitlementsComponent } from './user-check-entitlements/user-check-entitlements.component';
import { UserComponent } from './user/user.component';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    FooterComponent,
    NavComponent,
    MessageComponent,
    UserCheckEntitlementsComponent,
    UserComponent
  ],
  exports: [
    FooterComponent,
    NavComponent,
  ],
  imports: [
    AppRoutingModule,
    CommonModule
  ]
})
export class CoreModule { }
